'use client';
import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { z } from 'zod';
import { Button, Textarea } from '@/components/atoms';
import { SelectField } from '../SelectField/SelectField';
import { cn } from '@/lib/utils';
import { useTranslate } from '@tolgee/react';

const reasonOptions = (t: Function) => [
  { label: '', value: '', hidden: true },
  {
    label: t('report_seller_form.trademark_copyright_dmca'),
    value: 'Trademark, Copyright or DMCA Violation',
  },
];

const formSchema = (t: Function) => z.object({
  reason: z.string().nonempty(t('report_seller_form.reason_validation_error')),
  comment: z.string().nonempty(t('report_seller_form.comment_validation_error')),
});

type FormData = z.infer<ReturnType<typeof formSchema>>;

export const ReportSellerForm = ({
  onClose,
}: {
  onClose: () => void;
}) => {
const { t } = useTranslate();
  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitted },
    setValue,
    clearErrors,
  } = useForm<FormData>({
    resolver: zodResolver(formSchema(t)),
    defaultValues: {
      reason: '',
      comment: '',
    },
  });

  const onSubmit = (data: FormData) => {
    console.log('Form Data:', data);
  };

  return (
    <div>
      {!isSubmitted ? (
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className='px-4 pb-5'>
            <label className='label-sm'>
              <p
                className={cn(
                  errors?.reason && 'text-negative'
                )}
              >
                {t('report_seller_form.reason_label')}
              </p>
              <SelectField
                options={reasonOptions(t)}
                {...register('reason')}
                selectOption={(value) => {
                  setValue('reason', value);
                  clearErrors('reason');
                }}
                className={cn(
                  errors?.reason && 'border-negative'
                )}
              />
              {errors?.reason && (
                <p className='label-sm text-negative'>
                  {errors.reason.message}
                </p>
              )}
            </label>

            <label className='label-sm'>
              <p
                className={cn(
                  'mt-5',
                  errors?.comment && 'text-negative'
                )}
              >
                {t('report_seller_form.comment_label')}
              </p>
              <Textarea
                rows={5}
                {...register('comment')}
                className={cn(
                  errors.comment && 'border-negative'
                )}
              />
              {errors?.comment && (
                <p className='label-sm text-negative'>
                  {errors.comment.message}
                </p>
              )}
            </label>
          </div>

          <div className='border-t px-4 pt-5'>
            <Button
              type='submit'
              className='w-full py-3 uppercase'
            >
              {t('report_seller_form.report_seller_button')}
            </Button>
          </div>
        </form>
      ) : (
        <div className='text-center'>
          <div className='px-4 pb-5'>
            <h4 className='heading-lg uppercase'>
              {t('report_seller_form.thank_you_heading')}
            </h4>
            <p className='max-w-[466px] mx-auto mt-4 text-lg text-secondary'>
              {t('report_seller_form.report_seller_form')}
            </p>
          </div>

          <div className='border-t px-4 pt-5'>
            <Button
              className='w-full py-3 uppercase'
              onClick={onClose}
            >
              {t('report_seller_form.got_it_button')}
            </Button>
          </div>
        </div>
      )}
    </div>
  );
};
